export default {"src":"/_next/static/media/ad-service.ebb3c3a7.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};